import React, { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import featuresConfig from '../config/features.json';

const Features: React.FC = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const { features } = featuresConfig;

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % features.length);
    }, 8000); // Slower auto-rotation

    return () => clearInterval(interval);
  }, [features.length]);

  useEffect(() => {
    // Animate content change
    gsap.fromTo(
      '.feature-content.active',
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }
    );
  }, [activeFeature]);

  const handleFeatureClick = (index: number) => {
    setActiveFeature(index);
  };

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2>Everything You Need to Grow Your Business</h2>
        </div>
        
        <div className="features-carousel">
          <div className="features-row">
            {features.map((feature, index) => (
              <div
                key={feature.id}
                className={`feature-icon-item ${activeFeature === index ? 'active' : ''}`}
                data-feature={feature.id}
                onClick={() => handleFeatureClick(index)}
              >
                <div className="icon-wrapper">
                  <i className={feature.icon}></i>
                </div>
                <span className="icon-label">{feature.title}</span>
              </div>
            ))}
          </div>
          
          <div className="feature-details">
            {features.map((feature, index) => (
              <div
                key={feature.id}
                className={`feature-content ${activeFeature === index ? 'active' : ''}`}
                data-feature={feature.id}
              >
                <div className="feature-image">
                  <div className="feature-image-container">
                    <img 
                      src={feature.image} 
                      alt={feature.title}
                      className="feature-img"
                    />
                    <div className="image-overlay">
                      <i className={feature.icon}></i>
                    </div>
                  </div>
                </div>
                
                <div className="feature-text">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                  <ul className="feature-benefits">
                    {feature.benefits.map((benefit, benefitIndex) => (
                      <li key={benefitIndex}>
                        <i className="fas fa-check"></i>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features; 